import React from "react";

const DarkmodeContext = React.createContext({
    isDark: true
})